import Title from "../Home/Components/Title/Title";
import useScrollToTop from "../../hooks/useScrollToTop";
import { useTranslation } from "../../i18n/LanguageProvider";
import LegalPage from "./Components/LegalPage";
import LegalSection from "./Components/LegalSection";
import "./Legal.sass";

function TermsConditions() {
    const { t } = useTranslation();
    const sections = t("legal.termsSections") || [];

    useScrollToTop();

    return (
        <LegalPage title={<Title text={t("legal.termsTitle")} />} updatedAt={t("legal.termsUpdated")}>
            {sections.map((section) => (
                <LegalSection key={section.title} title={section.title}>
                    {(section.paragraphs || []).map((paragraph) => (
                        <p key={paragraph}>{paragraph}</p>
                    ))}
                    {section.list && (
                        <ul>
                            {section.list.map((item) => (
                                <li key={item}>{item}</li>
                            ))}
                        </ul>
                    )}
                </LegalSection>
            ))}
        </LegalPage>
    );
}

export default TermsConditions;
